// Everything the Action Required surface counts and lists: parked agent runs
// (GET /api/agents/inbox) plus, when Orion Pulsars is on in this region, pulsar
// proposal batches and questions (GET /api/standing-agents/attention). Both are
// DB-authoritative; the attention call failing (feature off → 404, older API)
// only drops the pulsar items, never the run items.

import type { AgentInboxItem, AttentionItem } from '@shared/api-types';
import { getAgentInbox } from './agentApi';
import { getAttention } from './standingAgentApi';

export interface ActionItems {
  runs: AgentInboxItem[];
  /** Pulsar batches + questions (halted pulsars live on the Pulsars page, not here). */
  pulsar: AttentionItem[];
}

export async function loadActionItems(): Promise<ActionItems> {
  const [runs, attention] = await Promise.all([getAgentInbox(), getAttention().catch(() => null)]);
  const pulsar =
    attention && attention.enabled === true && Array.isArray(attention.items)
      ? attention.items.filter((i) => i.kind === 'batch' || i.kind === 'question')
      : [];
  return { runs, pulsar };
}

export function actionItemCount(items: ActionItems): number {
  return items.runs.length + items.pulsar.length;
}
